import { render, staticRenderFns } from "./consult_list.vue?vue&type=template&id=49891fd2&scoped=true&"
import script from "./consult_list.vue?vue&type=script&lang=js&"
export * from "./consult_list.vue?vue&type=script&lang=js&"
import style0 from "./consult_list.vue?vue&type=style&index=0&id=49891fd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49891fd2",
  null
  
)

export default component.exports